// extracted by mini-css-extract-plugin
export default {"container":"vplLrC","support-text":"QH1IEk","supportText":"QH1IEk"};